import React, { useEffect, useRef } from 'react';

function TextBlur({ text, setVisibleElement, isVisible }) {
  const ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (isInView) {
          setVisibleElement(ref.current);
        }
      }
    };

    const applyMobileClass = () => {
      if (window.innerWidth <= 768) {
        ref.current?.classList.add('fade-up');
      } else {
        ref.current?.classList.remove('fade-up');
      }
    };

    applyMobileClass();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', applyMobileClass);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', applyMobileClass);
    };
  }, [setVisibleElement]);

  return (
    <div ref={ref} className={`text-blur ${isVisible ? 'visible' : ''}`}>
      <h2>{text}</h2>
    </div>
  );
}

export default TextBlur;

